import { XIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { FieldError } from "@/components/ui/field";
import { useIntakeMessages } from "./intake-messages";
import type { useTicketIntake } from "./use-ticket-intake";

export function TicketIntakeCustomerSummary({ form }: { form: ReturnType<typeof useTicketIntake> }) {
  const m = useIntakeMessages();
  const { values, busy, errors } = form;
  if (!values) return null;

  return (
    <>
      {values.context.customerId || values.context.orderId ? (
        <dl className="flex flex-col gap-3 text-sm">
          {values.context.customerId ? (
            <div className="flex items-start gap-4">
              <dt className="w-20 shrink-0 pt-1 text-muted-foreground">{m.member}</dt>
              <dd className="flex min-w-0 flex-1 items-start gap-2">
                <span className="min-w-0 break-words pt-1">{String(values.context.customerIdLabel || values.context.customerId)}</span>
                <Button type="button" variant="ghost" size="icon-sm" disabled={busy} aria-label={m.unlinkCustomer} onClick={() => form.selectCustomer(null)}>
                  <XIcon />
                </Button>
              </dd>
            </div>
          ) : null}
          {values.context.orderId ? (
            <div className="flex items-start gap-4">
              <dt className="w-20 shrink-0 text-muted-foreground">{m.order}</dt>
              <dd className="min-w-0 flex-1 break-words">{String(values.context.orderIdLabel || values.context.orderId)}</dd>
            </div>
          ) : null}
        </dl>
      ) : null}
      {errors.customerId ? <FieldError id="intake-customer-error">{errors.customerId}</FieldError> : null}
      {errors.orderId ? <FieldError>{errors.orderId}</FieldError> : null}
    </>
  );
}
